import React, { Component } from 'react';
import styled from 'styled-components';
import GenericDialog from '../GenericDialog';

const DialogStyled = styled(GenericDialog)`

`;

class ChannelNameDialog extends Component {
  render() {
    const {
      ...other
    } = this.props;

    return (
      <DialogStyled {...other} />
    );
  }
}

ChannelNameDialog.propTypes = {
};

ChannelNameDialog.defaultProps = {
};

export default ChannelNameDialog;
